( function( $ ) {
    $( '.sc-tdih-dropdown' ).on( 'change', function() {
        $( $( this ).closest( 'form' )[ 0 ] ).attr( 'action', window.location.href.replace( /\/page\/\d+\//gm, `/` ) );
        $( this ).closest( 'form' )[ 0 ].submit();
        $( this ).closest( 'form' ).find( '#overlay_working' ).css( 'display', 'initial' );
    } );
    $( 'form#materials-search-form' ).on( 'submit', function() {
        $( this ).closest( 'form' ).find( '#overlay_working' ).css( 'display', 'initial' );
    } );
}( jQuery ) );

const searchTaxonomies = [ 'period', 'themes', 'media_types', 'levels' ];
const searchUrlParams = {};
const searchTermLabels = {};

window.addEventListener( 'load', async () => {
    const algoliaSearchBox = document.getElementById( 'algolia-search-box' );

    await fetch( zinn_ed.admin_ajax, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'max-age=604800',
        },
        credentials: 'same-origin',
        body: new URLSearchParams( { action: 'term_labels' } ).toString(),
    } )
        .then( ( response ) => response.json() )
        .then( ( data ) => {
            for ( const [ taxonomy, terms ] of Object.entries( data ) ) {
                const labels = {};

                for ( const [ slug, label ] of Object.entries( terms ) ) {
                    labels[ slug ] = label;
                }

                searchTermLabels[ taxonomy ] = labels;
            }
        } );

    if ( algoliaSearchBox ) {
        const urlSearchParams = new URLSearchParams( window.location.search );

        searchUrlParams.query = urlSearchParams.get( 's' ) ?? '';
        searchUrlParams.page = urlSearchParams.get( 'page' ) ?? 1;

        searchTaxonomies.forEach( ( taxonomy ) => {
            if ( urlSearchParams.has( taxonomy ) ) {
                searchUrlParams[ taxonomy ] = urlSearchParams.get( taxonomy );
            }
        } );

        let search = {};

        if ( 'instant' === algoliaSearchBox.dataset.location ) {
            search = instantsearch( {
                indexName: algolia.indices.searchable_posts.name,
                searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
                routing: {
                    router: instantsearch.routers.history( {
                        createURL( { qsModule, routeState } ) {
                            const queryParameters = {};

                            if ( routeState.s ) {
                                queryParameters.s = routeState.s;
                            }

                            searchTaxonomies.forEach( ( taxonomy ) => {
                                if ( routeState[ taxonomy ] ) {
                                    queryParameters[ taxonomy ] = routeState[ taxonomy ];
                                }
                            } );

                            if ( routeState.page && 1 !== routeState.page ) {
                                queryParameters.page = routeState.page;
                            }

                            const queryString = qsModule.stringify( queryParameters, {
                                addQueryPrefix: true,
                                arrayFormat: 'repeat',
                            } );

                            return `${ window.location.protocol }//${ window.location.host }/${ queryString }`;
                        },
                        parseURL() {
                            return searchUrlParams;
                        },
                    } ),
                    stateMapping: {
                        stateToRoute( uiState ) {
                            const indexUiState = uiState[ algolia.indices.searchable_posts.name ] || {};

                            const stateToRoute = {
                                s: indexUiState.query,
                                page: indexUiState.page,
                            };

                            if ( indexUiState.menu ) {
                                searchTaxonomies.forEach( ( taxonomy ) => {
                                    if ( indexUiState.menu[ `taxonomies.${ taxonomy }` ] ) {
                                        stateToRoute[ taxonomy ] = indexUiState.menu[ `taxonomies.${ taxonomy }` ];
                                    }
                                } );
                            }

                            return stateToRoute;
                        },
                        routeToState( routeState ) {
                            const indexUiState = {};
                            const menu = {};
                            const routeToState = {
                                query: routeState.s,
                                page: routeState.page,
                            };

                            searchTaxonomies.forEach( ( taxonomy ) => {
                                if ( routeState[ taxonomy ] ) {
                                    menu[ taxonomy ] = routeState[ taxonomy ];
                                }
                            } );

                            indexUiState[ algolia.indices.searchable_posts.name ] = routeToState;

                            return indexUiState;
                        },
                    },
                },
            } );
        }

        if ( 'external' === algoliaSearchBox.dataset.location ) {
            search = instantsearch( {
                indexName: algolia.indices.searchable_posts.name,
                searchClient: algoliasearch( algolia.application_id, algolia.search_api_key ),
            } );
        }

        if ( 'instant' === algoliaSearchBox.dataset.location ) {
            search.addWidgets( [

                instantsearch.widgets.configure( {
                    hitsPerPage: 20,
                } ),

                instantsearch.widgets.hits( {
                    container: '#algolia-hits',
                    templates: {
                        empty( results ) {
                            return `<p>No results were found for "<strong>${ results.query }</strong>".`;
                        },
                        item( hit ) {
                            const thumbnail = ( hit.images && hit.images.large ) ? `
                                <a href="${ hit.permalink }" title="${ hit.post_title }">
                                    <img src="${ hit.images.large.url ?? '' }" alt="${ hit.post_title }" width="${ hit.images.large.width ?? '' }" height="${ hit.images.large.height ?? '' }" decoding="async" loading="lazy">
                                </a>
                            ` : ``;

                            return `
                                <article id="post-${ hit.post_id }" class="search-result grid-x grid-margin-x" role="article">
                                    <div class="medium-5 large-3 cell">
                                        ${ thumbnail }
                                    </div>
                                    <div class="medium-7 large-9 cell">
                                        <h2><a href="${ hit.permalink }">${ hit._highlightResult.post_title.value }</a></h2>
                                        <div class="search-result__description">${ hit._highlightResult.post_excerpt.value }</div>
                                        <a href="${ hit.permalink }" class="button">Continue reading</a>
                                    </div>
                                </article>
                            `;
                        },
                    },
                    escapeHTML: false,
                } ),

                instantsearch.widgets.pagination( {
                    container: '#algolia-pagination',
                } ),
            ] );
        }

        searchTaxonomies.forEach( ( taxonomy ) => {
            const renderMenuSelect = ( renderOptions, isFirstRender ) => {
                const { items, refine, widgetParams } = renderOptions;

                if ( ! widgetParams.container ) {
                    return;
                }

                if ( isFirstRender ) {
                    const select = document.createElement( 'select' );

                    select.name = taxonomy;

                    select.addEventListener( 'change', ( event ) => {
                        refine( event.target.value );
                    } );

                    widgetParams.container.appendChild( select );

                    const allOption = document.createElement( 'option' );
                    allOption.value = '';
                    allOption.textContent = 'All';

                    select.appendChild( allOption );

                    if ( searchUrlParams[ taxonomy ] ) {
                        refine( searchUrlParams[ taxonomy ] );
                    }
                }

                const select = widgetParams.container.querySelector( 'select' );

                select.querySelectorAll( '.algolia-facet' ).forEach( ( e ) => e.remove() );

                items.forEach( ( item ) => {
                    const option = document.createElement( 'option' );

                    let label = item.label;

                    if ( searchTermLabels[ taxonomy ] && searchTermLabels[ taxonomy ][ item.value ] ) {
                        label = searchTermLabels[ taxonomy ][ item.value ];
                    }

                    option.value = item.value;
                    option.textContent = `${ label } (${ item.count })`;
                    option.classList.add( 'algolia-facet' );

                    if ( item.isRefined ) {
                        option.selected = true;
                    }

                    select.appendChild( option );
                } );
            };

            const customMenuSelect = instantsearch.connectors.connectMenu( renderMenuSelect );

            search.addWidgets( [
                customMenuSelect( {
                    container: document.querySelector( `#facet-${ taxonomy }` ),
                    attribute: `taxonomies.${ taxonomy }`,
                    limit: 100,
                } ),
            ] );
        } );

        const renderSearchBox = ( renderOptions, isFirstRender ) => {
            const { query, refine, widgetParams } = renderOptions;

            if ( isFirstRender ) {
                const input = document.createElement( 'input' );
                const wrapper = document.createElement( 'span' );
                const heading = document.querySelector( 'h1 .search-results-terms' );

                input.classList.add( 'facetwp-search' );
                input.name = 's';
                input.placeholder = 'Search...';

                input.addEventListener( 'input', ( event ) => {
                    refine( event.target.value );

                    if ( heading ) {
                        heading.textContent = event.target.value;
                    }
                } );

                wrapper.classList.add( 'facetwp-input-wrap' );
                wrapper.appendChild( input );

                widgetParams.container.appendChild( wrapper );

                if ( searchUrlParams.query ) {
                    refine( searchUrlParams.query );
                }
            }

            widgetParams.container.querySelector( 'input' ).value = query;
        };

        const customSearchBox = instantsearch.connectors.connectSearchBox( renderSearchBox );

        search.addWidgets( [
            customSearchBox( {
                container: document.querySelector( '#algolia-search-box' ),
            } ),
        ] );

        search.start();
    }
} );

const searchFormExpander = document.querySelector( '#search-form-expander' );
const searchFormControls = document.querySelector( '#materials-search-form' );

if ( searchFormExpander ) {
    searchFormExpander.addEventListener( 'click', () => {
        const isExpanded = searchFormControls.classList.contains( 'expanded' );

        searchFormExpander.classList.toggle( 'expanded', ! isExpanded );
        searchFormControls.classList.toggle( 'expanded', ! isExpanded );
    } );
}
